<router-outlet></router-outlet>
<ngx-spinner
size="medium"
color="#fff"
type="ball-scale-multiple"></ngx-spinner>